import { CrownIcon, Paragraph, UserIcon } from "@datagame/ui";
import classNames from "classnames/bind";

import { UserRole } from "../../../../gql/graphql";

import styles from "./RoleBadge.module.scss";

const cx = classNames.bind(styles);

export interface RoleBadgeProps {
  role: UserRole;
}

export const RoleBadge = ({ role }: RoleBadgeProps) => {
  const renderIcon = () => {
    if (role === UserRole.Admin) {
      return <CrownIcon className={styles.adminIcon} />;
    }
    return <UserIcon className={styles.userIcon} />;
  };
  return (
    <div className={cx("badge", role)}>
      {renderIcon()}
      <Paragraph size="small" weight="font-bold" className={cx("role", role)}>
        {role}
      </Paragraph>
    </div>
  );
};
